import moment from 'moment';
import SourceStaff from 'sources/sourceTypes/Staff';
import Staff from 'types/Staff';

export const toSource = (_obj: Staff): SourceStaff => {
  return new SourceStaff();
};

export const toType = (sourceObj: SourceStaff): Staff => {
  const staff = new Staff();

  staff.id = sourceObj.id;
  staff.firstName = sourceObj.first_name;
  staff.lastName = sourceObj.last_name;
  staff.profileImage = sourceObj.profile_image;
  staff.createdAt = moment(sourceObj.created_at);
  staff.updatedAt = moment(sourceObj.updated_at);

  return staff;
};
